import React from 'react'
import Accordion from '../Accordion/Accordion'

const FAQs = ({title, data}) => {
    return (
        <>
            <div className="container py-5">

                <div className='faq-section mb-5'>
                    <h1 className=' mb-3 text-center'>
                        {title || "Your questions about FleetSense™, answered."}
                    </h1>
                    <p className='text-center'>Get to know frequently asked questions.</p>
                    <Accordion data={data}/>
                </div>
            </div>
        </>
    )
}

export default FAQs